import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// styles
import "./styles.scss";
import logo from "../../assets/images/logo.png";
import phoneIcon from "../../assets/images/icons/icon-phone.svg";

function Header({ style, notHome }) {
  const [show, setShow] = useState(false);
  const [header, setHeader] = useState("header");

  const listenScrollEvent = (event) => {
    if (window.scrollY < 50) {
      return setHeader("header");
    } else if (window.scrollY > 50) {
      return setHeader("header2");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  function toggleShow() {
    setShow(!show);
  }

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  return (
    <>
      <div style={style} className={`header-container ${header}`}>
        <div className="container">
          <nav className="navbar navbar-expand-md">
            <Link to="/" className="navbar-brand">
              <img className="logo" src={logo} alt="value360 logo" />
            </Link>
            <div
              className={`navbar-toggler ${show ? "show" : ""}`}
              onClick={toggleShow}
            >
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
              <span className="navbar-toggler-icon"></span>
            </div>

            <div className={`navbar-collapse ${show ? "show" : ""}`}>
              <ul className="navbar-nav ml-auto">
                {/* <li className="nav-item" onClick={toggleShow}>
                  <a className="nav-link" href="#contactus">
                    Contact us
                  </a>
                </li> */}
                <li className="nav-item" onClick={toggleShow}>
                  <a
                    className="nav-link"
                    href={`${notHome ? "/" : ""}#aboutus`}
                  >
                    About us
                  </a>
                </li>

                <li className="nav-item" onClick={toggleShow}>
                  <a
                    className="nav-link"
                    href={`${notHome ? "/" : ""}#services`}
                  >
                    Services
                  </a>
                </li>
                <li className="nav-item" onClick={toggleShow}>
                  <a href="tel:+6531658101" className="nav-link">
                    <img
                      className="icon phone"
                      src={phoneIcon}
                      alt="icon phone"
                    />{" "}
                    +6531658101
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
}
export default Header;
